import React from "react"
import { SerpContextData } from "../../../aggregators/serp/types"

export const AlgoliaSerpDataContext = React.createContext<SerpContextData>(
  {} as any
)

export const useAlgoliaSerpDataContext = () =>
  React.useContext(AlgoliaSerpDataContext)
